/* eslint-disable react/prop-types */

import _ from 'underscore';
import classnames from 'classnames';
import React, { useMemo } from 'react';

import { getAdPlacementComponent } from './get-ad-placement-component';
import { withUAPLThemedStyles } from '../with-themed-styles';
import { getAdPreviewSinglePlacementLayoutStyles } from '../styles';
import { pickSingleImageFromImageList } from '../ad-preview-model/use-ad-preview-model';

// import {
//   UAPVMSingleImagePlacement as TSingleImageViewModel,
//   UAPVMPlacement as TMultiImageViewModel,
// } from '../@types';

// interface SinglePlacementLayoutProps {
//   placementData: TSingleImageViewModel | TMultiImageViewModel | undefined | null;
//   onRenderPlacement: Function;
//   onRenderEmptyView?: Function | undefined | null;
//   layoutContainerClassName?: String | undefined | null;
//   classes: {
//     adPreviewLayoutContainer: string;
//   };
// }

const SinglePlacementLayout = ({
  placementData, // SinglePlacementLayoutProps
  onRenderPlacement,
  onRenderEmptyView,
  layoutContainerClassName,
  hasContainer = true,
  classes,
}) => {
  const emptyView = useMemo(() => {
    if (onRenderEmptyView) {
      return onRenderEmptyView(placementData);
    }
    return null;
  }, [onRenderEmptyView, placementData]);

  const placementComponent = useMemo(() => {
    const { placementMeta, images, ...rest } = placementData || {};
    const { placementType, hasMultiImages = false } = placementMeta || {};
    const AdPlacementComponent = getAdPlacementComponent(placementType);
    if (AdPlacementComponent) {
      // convert multi-image model to single-image model if needed
      if (!hasMultiImages && !_.isEmpty(images)) {
        const selectedImage = pickSingleImageFromImageList(images) || {};
        const newPlacement = { placementMeta, ...selectedImage, ...rest };
        return onRenderPlacement(newPlacement, AdPlacementComponent);
      }
      return onRenderPlacement(placementData, AdPlacementComponent);
    }
    return null;
  }, [onRenderPlacement, placementData]);

  return hasContainer ? (
    <div className={classnames(classes.adPreviewLayoutContainer, layoutContainerClassName, 'single-placement')} >
      {placementComponent || emptyView}
    </div>
  ) : (
    <>
      {placementComponent || emptyView}
    </>
  );
};

export const AdPreviewSinglePlacementLayout = withUAPLThemedStyles(
  SinglePlacementLayout,
  getAdPreviewSinglePlacementLayoutStyles,
  { componentName: 'AdPreviewSinglePlacementLayout' }
);
